import { ComponentsModule } from './../../components/components.module';
import { ReadMoreComponent } from './read-more/read-more.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './../../material.module';
import { CommonModule } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [ReadMoreComponent],
	imports: [
		CommonModule,
		ComponentsModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		MaterialModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyDKjmrtV1_PoiO_lzghFvsJTOLNVadeEmM',
		}),
	],
})
export class OcorrencesModule {}
